<template>
  <div>
    <div class="content">
      <div class="lald-case__block-head-child d-md-none mb-8">
        <div class="lald-case__block-head-child-info">Денис (5 лет)</div>
        <div class="lald-case__block-head-child-avatar">
          <img
            :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy-avatar.png 2x`"
          />
        </div>
      </div>
      <div class="lald-case__block">
        <div class="lald-case__block-head">
          <div class="lald-case__block-head-title">Выдвинуть гипотезу</div>
          <div class="lald-case__block-head-child d-none d-md-flex">
            <div class="lald-case__block-head-child-info">Денис (5 лет)</div>
            <div class="lald-case__block-head-child-avatar">
              <img
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/laldICC/boy-avatar.png 2x`"
              />
            </div>
          </div>
        </div>
        <div class="lald-case__block-body">
          <div class="lald-case__block-body-form">
            <div class="lald-case__block-body-form-title">Ваша гипотеза:</div>
            <div class="lald-case__block-body-form-items">
              <label class="lald-case__block-body-form-item">
                <div class="lald-case__block-body-form-item-radio">
                  <input
                    type="radio"
                    v-model="variant"
                    value="1"
                    @change="$emit('changeVariant', 1)"
                  />
                  <div></div>
                </div>
                <div class="lald-case__block-body-form-item-label default-text">
                  Неалкогольная жировая болезнь печени
                </div>
              </label>
              <label class="lald-case__block-body-form-item">
                <div class="lald-case__block-body-form-item-radio">
                  <input
                    type="radio"
                    v-model="variant"
                    value="2"
                    @change="$emit('changeVariant', 2)"
                  />
                  <div></div>
                </div>
                <div class="lald-case__block-body-form-item-label default-text">
                  Семейная гиперхолестеринемия
                </div>
              </label>
              <label class="lald-case__block-body-form-item">
                <div class="lald-case__block-body-form-item-radio">
                  <input
                    type="radio"
                    v-model="variant"
                    value="3"
                    @change="$emit('changeVariant', 3)"
                  />
                  <div></div>
                </div>
                <div class="lald-case__block-body-form-item-label default-text">
                  Дефицит лизосомной кислой липазы
                </div>
              </label>
            </div>
            <div
            class="lald-case__button button button_orange-gradient mt-4"
            :class="{ button_disabled: !variant }"
            @click="$emit('toStep', 6)"
          >
            Установить диагноз
          </div>
          </div>
        </div>
      </div>
      <div class="lald-case__tools">
        <div class="lald-case__back" @click="$emit('back')">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.25 19.5L3.75 12L11.25 4.5"
              stroke="#8B8E8E"
              stroke-width="1.5"
              stroke-linecap="square"
            />
            <path
              d="M5.25 12L20.25 12"
              stroke="#8B8E8E"
              stroke-width="1.5"
              stroke-linecap="square"
            />
          </svg>
          Назад
        </div>
        <div class="lald-case__buttons">
          
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Step6",
  data: () => ({
    variant: null,
  }),
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/laldICC.scss";

.lald-case {
  &__block {
    &-body {
      &-form {
        &-title {
          margin-bottom: 20px;
          font-family: "Roboto Slab", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 22px;
          line-height: 29px;
          color: #5c539e;
        }
        &-item {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 12px;
          cursor: pointer;

          &:not(:last-child) {
            margin-bottom: 16px;
          }

          &-radio {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            flex-shrink: 0;
            border: 2px solid #5c539e;
            display: flex;
            justify-content: center;
            align-items: center;

            & > div {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: #5c539e;
              opacity: 0;
            }

            & > input {
              display: none;

              &:checked {
                & ~ div {
                  opacity: 1;
                }
              }
            }
          }
          &-label {
            margin: auto 0;
          }
        }
      }
    }
  }
}
</style>